import { useEffect } from 'react';

import { useExtensionPermissions } from '@/api/use-extension-permissions';
import {
  leadIntegrationEnabledAtom,
  outboundCallJournalEnabledAtom,
  store,
} from '@/lib/store';

export const useSetLeadIntegrationEnabled = () => {
  const { data: permissions } = useExtensionPermissions();
  useEffect(() => {
    store.set(
      leadIntegrationEnabledAtom,
      permissions?.leadIntegration === true
    );
    store.set(
      outboundCallJournalEnabledAtom,
      permissions?.outboundCallJournal === true
    );
  }, [permissions]);
};
